import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  Audit,
  BankAccountReviewIndex,
  BankAccountReviewShow,
  Dashboard,
  Invoices,
  MetricHistory,
  Metrics,
} from './MiscellaneousRouteComponents';

export const miscellaneousRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: Audit,
    path: `${adminRoutes.audit}/:id`,
  },
  {
    Component: Dashboard,
    path: adminRoutes.dashboard,
  },
  {
    Component: BankAccountReviewIndex,
    path: adminRoutes.bankAccountReviews,
    permitOnly: [UserRoles.Underwriting, UserRoles.UnderwritingManager, UserRoles.CarrierBankApprover,
      UserRoles.OpsManager, UserRoles.FraudTeamMember],
  },
  {
    Component: BankAccountReviewShow,
    path: `${adminRoutes.bankAccountReviews}/:id`,
    permitOnly: [UserRoles.Underwriting, UserRoles.UnderwritingManager, UserRoles.CarrierBankApprover,
      UserRoles.FraudTeamMember],
  },
  {
    Component: Invoices,
    path: adminRoutes.invoices,
  },
  {
    Component: Metrics,
    path: adminRoutes.metrics,
  },
  {
    Component: MetricHistory,
    path: `${adminRoutes.metricsHistory}/:metricId`,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
